// Vendor 54b86ba87de242249429ad7f

var stagingUrl = 'stagingrcm.axxessweb.com';
var devUrl = 'rcm.rcm.lan';
var localUrl = 'local.rcm.axxessweb.com';

var config = {
    isLocal: (document.domain === localUrl),
    accounts_url: isLocal ? 'http://dev.accounts.axxessweb.com' : 'https://accounts.axxessweb.com/login',
    api_url: (function () {
        var apiUrl = 'rcmapi.axxessweb.com',
            apiProtocol = location.protocol;

        isLocal = document.domain === localUrl;
        isStaging = (document.domain === stagingUrl);
        isDev = (document.domain === devUrl);

        if (isLocal) {
            apiUrl = 'rcmapi.rcm.lan';
        } else if (isDev || isStaging) {
            var rcmDomain = document.domain.split(".");
            rcmDomain[0] += 'api';
            apiUrl = rcmDomain.join('.');
        }
        if (isLocal || document.domain === devUrl) {
            apiProtocol = "http:";
        }
        else {
            apiProtocol = "https:";
        }

        return apiProtocol + "//" + apiUrl;
    })()
};

require.config({
    baseUrl: '/h/abcd1234/Client/app',
    paths: {

        // Require Plugins
        'text': '../lib/requirejs-text/text',
        'template': 'core/template',

        // Libraries
        'jquery': '../lib/jquery/jquery.min',
        'jquery-easing': '../lib/jquery-easing-original/jquery.easing.1.3.min',
        'jquery-throttle': '../lib/jquery-throttle-debounce/jquery.ba-throttle-debounce.min',
        'jquery-inputmask': '../lib/jquery.inputmask/dist/jquery.inputmask.bundle.min',
        'jquery-cookie': '../lib/jquery-cookie/jquery.cookie',
        'can': '../lib/canjs/amd/can',
        'bootstrap': '../lib/bootstrap-sass-official/assets/javascripts/bootstrap',
        'bootstrap-validation': '../lib/bootstrapValidator/dist/js/bootstrapValidator.min',
        'datepicker': '../lib/bootstrap-datepicker/dist/js/bootstrap-datepicker',
        'moment': '../lib/moment/min/moment.min',
        'mousetrap': '../lib/mousetrap/mousetrap.min',
        'highcharts': '../lib/highcharts-release/highcharts.src',
        'typeahead': '../lib/typeahead.js/dist/typeahead.jquery',
        'bloodhound': '../lib/typeahead.js/dist/bloodhound.min',
        'signalr.core': '../lib/signalr/jquery.signalR.min',
        'signalr.hubs': 'core/hubs',
        'faker': '../node_modules/faker/faker',
        'marked': '../lib/marked/lib/marked',
        'content': '../content',
        'oidc-client': '../lib/oidc-client/dist/oidc-client'
    },
    shim: {
        'jquery-easing': ['jquery'],
        'jquery-throttle': ['jquery'],

        // Bootstrap
        'bootstrap': ['jquery'],
        'datepicker': ['jquery', 'bootstrap'],
        'typeahead': ['jquery'],
        'bloodhound': {
            deps: ['jquery'],
            exports: 'Bloodhound'
        },
        'bootstrap-validation': {
            deps: ['jquery', 'bootstrap'],
            exports: 'FormValidation',
            init: function ($) {

                $.fn.bootstrapValidator.validators.ModelState = {
                    validate: function (validator, $field, options) {
                        return {
                            valid: false,
                            message: options.message.join('<br>')
                        };
                    }
                };

                $.fn.bootstrapValidator.validators.manual = {
                    validate: function (validator, $field, options) {
                        return {
                            valid: false,
                            message: options.message
                        };
                    }
                };
            }
        },
        'oidc-client': {
            init: function () {
                return this.Oidc;
            }
        },

        // SignalR
        'signalr.core': {
            deps: ['jquery'],
            exports: '$.connection'
        },
        'signalr.hubs': {
            deps: ['signalr.core'],
            exports: '$.connection'
        },

        // Highcharts
        'highcharts': {
            deps: ['jquery'],
            exports: 'Highcharts',
            init: function ($) {
                Highcharts.setOptions({
                    chart: {
                        style: {
                            fontFamily: 'Open Sans, Helvetica, sans-serif'
                        }
                    },
                    colors: [
                        '#87CEEB',
                        '#32CD32',
                        '#BA55D3',
                        '#F08080',
                        '#4682B4',
                        '#9ACD32',
                        '#40E0D0',
                        '#FF69B4',
                        '#F0E68C',
                        '#D2B48C',
                        '#8FBC8B',
                        '#6495ED',
                        '#DDA0DD',
                        '#5F9EA0',
                        '#FFDAB9',
                        '#FFA07A'
                    ],
                    xAxis: {
                        dateTimeLabelFormats: {
                            millisecond: "%b %e", // "%A, %b %e, %H:%M:%S.%L",
                            second: "%b %e", // "%A, %b %e, %H:%M:%S",
                            minute: "%b %e", // "%A, %b %e, %H:%M",
                            hour: "%b %e", // "%A, %b %e, %H:%M",
                            day: "%b %e",
                            week: "Week from %A, %b %e, %Y",
                            month: "%B %Y",
                            year: "%Y"
                        }
                    },
                    credits: {
                        enabled: false
                    }
                });

                // Max Point Width
                (function (H) {
                    var each = H.each;
                    H.wrap(H.seriesTypes.column.prototype, 'drawPoints', function (proceed) {
                        var series = this;
                        if (series.data.length > 0) {
                            var width = Math.min(series.barW, 50);
                            each(this.data, function (point) {
                                point.shapeArgs.x += (point.shapeArgs.width - width) / 2;
                                point.shapeArgs.width = width;
                            });
                        }
                        proceed.call(this);
                    });
                })(Highcharts)
            }
        }
    }
});

require([
    'jquery',
    'core/can',
    'core/validation',
    'models/Session',
    'moment',
    'bootstrap',
    'datepicker'
], function ($, can, V, Session, moment) {

    can.route.ready();

    // ----------------------------------------
    // AJAX Defaults and Prefilter
    // https://github.com/bitovi/canjs/issues/111
    // ----------------------------------------

    $.ajaxSetup({
        contentType: 'application/json',
        beforeSend: function (xhr, settings) {
            xhr.requestData = {
                url: settings.url,
                type: settings.type
            };
        }
    });

    $.ajaxPrefilter(function (options, orig, xhr) {

        // URL
        if (options.url.indexOf('http') !== 0)
            options.url = config.api_url + options.url;

        // Data
        if (options.processData
            && /^application\/json((\+|;).+)?$/i.test(options.contentType)
            && /^(post|put|delete)$/i.test(options.type)) {

            options.data = JSON.stringify(orig.data);
        }

        // Headers
        var token = Session.attr('Token');
        var accountId = can.route.attr('accountId');

        if (accountId === undefined) {
            accountId = Session.attr('AccountId');
        }

        if (token === undefined) {
            token = Session.attr('identityToken');
        }

        if (token) {
            if (can.isEmptyObject(options.headers))
                options.headers = {};
            options.headers.Authorization = 'Bearer ' + token;
        }
        if (accountId) {
            options.headers['X-Account-Id'] = accountId;
        }
    });

    // ----------------------------------------
    // Global AJAX Error Handlers
    // https://github.com/bitovi/canjs/issues/111
    // ----------------------------------------

    function handleAjaxError(xhr) {
        var status = xhr.status,
            errorMessage = '<p>Don\'t worry, we\'ll take care of it. Please try again or contact <a href="http://axxess.com/support" target="_blank">customer support</a>.</p>',
            errorData = xhr.responseText && xhr.responseText.length > 0 ? $.parseJSON(xhr.responseText) : {},
            isValidationError = (errorData.ModelState !== undefined),
            alertSize = 'sm',
            validationMessage = 'Please fix the following error(s) and <%=process=%> again.<br /><br />',
            requestData = xhr.requestData,
            requestType = requestData.type,
            processMsg = 'processing your request',
            process = 'submit',
            url = requestData.url.slice(config.api_url.length + 1), // +1 to skip the / after the api url
            model = url.split("/")[0],
            title = 'Error',
            actionId = xhr.getResponseHeader('X-Action-Id'),
            actionIdMsg = "",
            buttonText = 'OK';

        // TODO Make sure no other modal is up.
        if (window.App && window.App.loading) {
            window.App.loading(false);

            switch (status) {
                case 400: {
                    errorMessage = '<p>Oops! There was a problem while <%=processMsg=%>. '
                        + 'Please try again or contact <a href=\"http://axxess.com/support\" target=\"_blank\">customer support</a>.</p>';

                    if (isValidationError) {
                        alertSize = 'md';

                        for (var field in errorData.ModelState) {
                            validationMessage += errorData.ModelState[field] + '<br />';
                        }

                        errorMessage = "<p>" + validationMessage + " <br /> If the errors shown here are incorrect, please contact <a href=\"http://axxess.com/support\" target=\"_blank\">customer support</a>.</p>";
                    } else if (errorData.Message !== undefined) {
                        errorMessage = "<p>" + errorData.Message + " Please try again or contact <a href=\"http://axxess.com/support\" target=\"_blank\">customer support</a>.</p>";
                    }

                    if (requestType !== 'GET') {
                        switch (model.toLowerCase()) {
                            case 'claim':
                                processMsg = 'saving your claim';
                                break;

                            case 'credentials':
                                processMsg = 'saving your DDE credential';
                                process = 'save';
                                break;
                        }
                    }

                    errorMessage = errorMessage.replace("<%=processMsg=%>", processMsg);
                    errorMessage = errorMessage.replace("<%=process=%>", process);
                    break;
                }

                case 404:
                    title = 'Not Found';
					if (url.includes('Report/CancellationRates')) { 
						// window.App.confirm({
						// 	title: 'Need DDE Credential',
						// 	message: '<p>The RAP cancellation rate could not be calculated. Please confirm that a valid DDE credential has been added or contact <a href="http://axxess.com/support" target="_blank">customer support</a>.</p>',
						// 	okText: 'Update Credential',
						// 	cancelText: 'Not Now',
						// 	size: 'md',
						// 	ok: function() {
						// 		can.route.attr({
						// 			page: 'admin',
						// 			tab: 'credentials'
						// 		}, true);
						// 	}
						// });
						return;
					}
                    break;

                case 408:
                    title = 'Request Timed Out';
                    break;

                case 500:
                    title = 'Server Error';
                    break;

            }

            if (actionId !== undefined && actionId !== null && actionId.length > 0) {
                actionIdMsg = '<small class="default">Incident ID ' + actionId + '</small>';
            }

            window.App.alert({
                title: title,
                message: errorMessage + actionIdMsg,
                buttonText: buttonText,
                size: 'md',
                ok: xhr.callback || ''
            });
        }
    }

    $.ajaxSetup({
        statusCode: {
            400: handleAjaxError,
            // If a 401 status code comes back, the user is no longer 
            // logged in and must re-authenticate.
            401: function () {
                Session.destroy();
            },
            // Forbidden
            403: function () {
                window.App.denyPermission('server');
            },
            // Not Found
            404: handleAjaxError,
            // Method Not Allowed
            405: handleAjaxError,
            // If the request timed out
            408: handleAjaxError,
            // If the DDE credentials are inactive.
            421: function () {
                window.App.alert({
                    title: 'Error',
                    message: "<p>Oops! Your DDE credential is invalid. Please select the button to update your DDE credentials. If the problem persists, please try again or contact <a href=\"http://axxess.com/support\" target=\"_blank\">customer support</a>.</p>",
                    buttonText: "Update Credential",
                    ok: function () {
                        can.route.attr({
                            page: 'admin',
                            tab: 'credentials'
                        }, true);
                    },
                    size: 'md'
                });
            },
            // Internal Server Error
            500: handleAjaxError
        }
    });


    // ----------------------------------------
    // Manage Authentication State Changes
    // ----------------------------------------

    function el(options) {
        var div = $('<div>', options);
        $(document.body).append(div);
        return div;
    }

    function goAccounts() {
        // var redirecturl = '/' + window.location.hash;
        // window.location = config.accounts_url + '?ReturnUrl=' + encodeURIComponent(redirecturl);
        window.location = config.accounts_url;
    }

    Session.bind('started', function () {
        require(['pages/app/AppController'], function (controller) {
            var App = window.App = new controller(el({ id: 'App__Controller' }));
        });
    })
        .bind('destroyed', goAccounts)
        .start().fail(function (xhr) {
            var options = {
                title: 'Login Failed',
                message: 'Please make sure you are using the email address and password you used to sign up for AxxessDDE.',
                buttonText: 'Log In',
                ok: goAccounts
            },
                modalId = 'modals/alert/AlertModal';

            if (xhr && xhr.status !== 401) {
                var actionId = xhr.getResponseHeader('X-Action-Id');
                options.title = 'Error';
                options.message = 'Oops! There was a problem while logging you in. Please try again or contact <a href=\"http://axxess.com/support\" target=\"_blank\">customer support</a>.<br><small class="default">Incident ID ' + actionId + '</small>';
                options.buttonText = 'Ok';
            }

            require([modalId], function (modal) {
                var div = $('<div>', {
                    'id': 'AlertModal__Modal',
                    'class': 'modal fade',
                    'tabindex': '-1',
                    'role': 'dialog',
                    'aria-hidden': 'true'
                });
                $('body').append(div);
                new modal(div, options);
            });
        });

    // TODO beforeunload
    // "You've modified your fiddle, reloading the page will reset all changes.\n\nAre you sure you want to leave this page?"

});
define("main", function(){});

